import { tracker as CLICKSTREAM } from '@zg-rentals/clickstream';
import { tracker as COMSCORE } from '@zg-rentals/comscore/client';
import { tracker as GTM } from '@zg-rentals/google-tag-manager';
import { defineAnalytics } from '@zg-rentals/rentals-analytics';

import type {
  ClickstreamPayload,
  ZrmLeaseInfo,
  ZrmListingInfo,
  ZrmRentalProtectionInfo,
  ZrmUserInfo,
} from '@zg-rentals/clickstream';

export const analytics = defineAnalytics({ GTM, COMSCORE, CLICKSTREAM });

export const trackComscoreEvent = analytics.createTrackEvent('COMSCORE');
export const trackGtmEvent = analytics.createTrackEvent('GTM');

const trackBaseEvent = analytics.createTrackEvent<'CLICKSTREAM', ClickstreamPayload>('CLICKSTREAM');
const trackUserEvent = analytics.createTrackEvent<'CLICKSTREAM', ClickstreamPayload<ZrmUserInfo>>('CLICKSTREAM');
const trackLeaseEvent = analytics.createTrackEvent<'CLICKSTREAM', ClickstreamPayload<ZrmLeaseInfo>>('CLICKSTREAM');
const trackLeaseUserEvent = analytics.createTrackEvent<'CLICKSTREAM', ClickstreamPayload<ZrmLeaseInfo & ZrmUserInfo>>(
  'CLICKSTREAM',
);
const trackListingUserEvent = analytics.createTrackEvent<
  'CLICKSTREAM',
  ClickstreamPayload<ZrmListingInfo & ZrmUserInfo>
>('CLICKSTREAM');
const trackLeaseListingUserEvent = analytics.createTrackEvent<
  'CLICKSTREAM',
  ClickstreamPayload<ZrmListingInfo & ZrmLeaseInfo & ZrmUserInfo>
>('CLICKSTREAM');
const trackRpListingUserEvent = analytics.createTrackEvent<
  'CLICKSTREAM',
  ClickstreamPayload<ZrmListingInfo & ZrmRentalProtectionInfo & ZrmUserInfo>
>('CLICKSTREAM');

// for apps w/ many different variations of the same tracker, an object like this helps w/ usage
export const trackEvent = {
  base: trackBaseEvent,
  user: trackUserEvent,
  lease: trackLeaseEvent,
  leaseUser: trackLeaseUserEvent,
  leaseListingUser: trackLeaseListingUserEvent,
  listingUser: trackListingUserEvent,
  rpListingUser: trackRpListingUserEvent,
};
